/**
 * Returns a callback to remove a filter item by id.
 * It looks for an input element with the given id,
 * unchecks it and triggers a change event for that input.
 * @param {Element} filter
 * @param {string} [itemId]
 * @returns {Function} A callback function
 */
const handleItemRemove = (filter, itemId) => (e) => {
    const id = itemId || $(e.target).attr('data-id');

    $(filter)
        .find(`fieldset[name="${id}"] input`)
        .prop('checked', false)
        .removeAttr('checked') // fix for initially checked input markup
        .closest('fieldset')
        .trigger('select:reset');
};

export default handleItemRemove;



// WEBPACK FOOTER //
// ./src/scripts/components/filter/handleItemRemove.js